export const Utils = {

    groupBy(values, prop) {
        return values.reduce((rv, x) => {
            (rv[x[prop]] = rv[x[prop]] || []).push(x);
            return rv;
        }, {});
    }

}
